import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./userSlice";

const bussinessSlice = createSlice({
    name: "currentBusiness",
    initialState: {
        currentBusiness: null,
        currentBusinessOwnerName: '',
        customerId: '',
        card: false
    },
    reducers: {
        currentBusinessSave: (state, action) => {
            state.currentBusiness = action.payload;
        },
        currentBusinessOwnerNameSave: (state, action) => {
            state.currentBusinessOwnerName = action.payload;
        },
        currentBusinessOwnerCustomerId: (state, action) => {
            state.customerId = action.payload;
        },
        currentBusinessOwnerCardStatus: (state, action) => {
            state.card = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(logout, (state) => {
                state.currentBusiness = null
                state.currentBusinessOwnerName = ''
            });
    },
});

export const { currentBusinessSave,
    currentBusinessOwnerNameSave,
    currentBusinessOwnerCustomerId,
    currentBusinessOwnerCardStatus } = bussinessSlice.actions;
export default bussinessSlice.reducer;